<template>
    <div class="mb-10 mt-5 grid grid-cols-1 gap-6 md:grid-cols-3">
        <div
            class="rounded-[12.8px] border border-gray-200 bg-white p-6 transition-all duration-200 hover:shadow-md"
        >
            <div class="mb-4 flex items-start justify-between">
                <div
                    class="flex h-12 w-12 items-center justify-center rounded-[12.8px] bg-green-500"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-shield h-6 w-6 text-white"
                        aria-hidden="true"
                    >
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        ></path>
                    </svg>
                </div>
                <DeltaIndicator
                    v-if="statsBefore && statsBefore.pass"
                    :before="statsBefore.pass"
                    :now="stats.pass"
                />
            </div>
            <div>
                <p class="mb-1 text-sm text-gray-600">
                    {{ $t("vue.dmarc_compliant") }}
                </p>
                <p class="text-2xl font-semibold text-gray-900">
                    {{ new Intl.NumberFormat().format(stats.pass) }}
                </p>
            </div>
        </div>
        <div
            class="rounded-[12.8px] border border-gray-200 bg-white p-6 transition-all duration-200 hover:shadow-md"
        >
            <div class="mb-4 flex items-start justify-between">
                <div
                    class="flex h-12 w-12 items-center justify-center rounded-[12.8px] bg-red-500"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-shield-alert h-6 w-6 text-white"
                        aria-hidden="true"
                    >
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        ></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <DeltaIndicator
                    v-if="statsBefore && statsBefore.fail"
                    :before="statsBefore.fail"
                    :now="stats.fail"
                    :inverted="true"
                />
            </div>
            <div>
                <p class="mb-1 text-sm text-gray-600">
                    {{ $t("vue.dmarc_non_compliant") }}
                </p>
                <p class="text-2xl font-semibold text-gray-900">
                    {{ new Intl.NumberFormat().format(stats.fail) }}
                </p>
            </div>
        </div>
        <div
            class="rounded-[12.8px] border border-gray-200 bg-white p-6 transition-all duration-200 hover:shadow-md"
        >
            <div class="mb-4 flex items-start justify-between">
                <div
                    class="flex h-12 w-12 items-center justify-center rounded-[12.8px] bg-blue-500"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-mail h-6 w-6 text-white"
                        aria-hidden="true"
                    >
                        <path
                            d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"
                        ></path>
                        <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                    </svg>
                </div>
                <DeltaIndicator
                    v-if="
                        statsBefore && statsBefore.pass + statsBefore.fail > 0
                    "
                    :before="statsBefore.pass + statsBefore.fail"
                    :now="stats.pass + stats.fail"
                    :informative="true"
                />
            </div>
            <div>
                <p class="mb-1 text-sm text-gray-600">
                    {{ $t("vue.total_emails_reported") }}
                </p>
                <p class="text-2xl font-semibold text-gray-900">
                    {{
                        new Intl.NumberFormat().format(stats.pass + stats.fail)
                    }}
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineProps } from "vue";

defineProps<{
    stats: {
        pass: number;
        fail: number;
    };
    statsBefore: {
        pass: number;
        fail: number;
    } | null;
}>();
</script>
